import { faCaretUp } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Caret Up icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/caret-up?f=classic&s=solid
 */
export const CaretUpIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCaretUp} {...props} />;
};
